import { handleActions } from 'redux-actions'
import { REQUEST_STATUSES } from '@/constants/requests'
import generateDefaultTableReducer, {
  generateTableParameter,
} from '@/helpers/table/generateDefaultTableReducer'
import generateDefaultTableState from '@/helpers/table/generateDefaultTableState'
import {
  GET_FAULT_ANALYTICS_TABLE,
  GET_FAULT_ANALYTICS_FILE,
  FAULT_ANALYTICS_TABLE,

  SET_SELECTED_ELEMENT,
  SET_EVETS_DATA,
} from '@/store/actions/faultAnalytics'
import { fields } from '@/constants/tablesConfig/faultAnalytics'

const initialState = {
  fileExportStatus: REQUEST_STATUSES.NOT_REQUESTED,
  data: [],
  startDate: null,
  endDate: null,
  selector: 'all',
  eventStatus: ['all'],
  selectedElement: null,
  loading: false,
  table: generateDefaultTableState(fields),
}

export const reducer = handleActions(
  {
    [SET_EVETS_DATA]: (state, { payload: { eventsCount, eventData } }) => ({
      ...state,
      eventsCount,
      eventData,
    }),
    [SET_SELECTED_ELEMENT]: (state, { payload }) => ({
      ...state,
      selectedElement: payload,
    }),
    [GET_FAULT_ANALYTICS_TABLE.REQUEST]: (state) => ({
      ...state,
      loading: true,
    }),
    [GET_FAULT_ANALYTICS_TABLE.SUCCESS]: (state, { payload: { data, totalElements } }) => ({
      ...state,
      data,
      loading: false,
      ...generateTableParameter(state, 'resultCount', totalElements),
    }),
    [GET_FAULT_ANALYTICS_TABLE.ERROR]: (state, { payload }) => ({
      ...state,
      ...payload,
      loading: false,
    }),
    [GET_FAULT_ANALYTICS_FILE.REQUEST]: (state) => ({
      ...state,
      fileExportStatus: REQUEST_STATUSES.PENDING,
    }),
    [GET_FAULT_ANALYTICS_FILE.SUCCESS]: (state) => ({
      ...state,
      fileExportStatus: REQUEST_STATUSES.IDLE,
    }),
    [GET_FAULT_ANALYTICS_FILE.ERROR]: (state) => ({
      ...state,
      fileExportStatus: REQUEST_STATUSES.ERROR,
    }),
    ...generateDefaultTableReducer(FAULT_ANALYTICS_TABLE),
  },
  initialState,
)

export default reducer
